import { render, staticRenderFns } from "./PerfilBalanceView.vue?vue&type=template&id=77369926&scoped=true"
import script from "./PerfilBalanceView.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilBalanceView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PerfilBalanceView.vue?vue&type=style&index=0&id=77369926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77369926",
  null
  
)

export default component.exports